import * as types from "./view-assigned.type";

import { renderDisc } from "../../../helpers/component-helper";

let initialState = {
  data: [],
  currentPage: 1,
  pageSize: 10,
  totalPages: 1,
  isLoading: false,
  isSuccessUpdateOrderType: false,
  form: {
    showErrors: false,
    validationErrors: {},
  },
};

const viewAssignedReducer = (state = initialState, action) => {
  switch (action.type) {
    default:
      return state;
    case types.FE_ASSIGNED_ORDERS_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case types.FE_ASSIGNED_ORDERS_SUCCESS:
    case types.FE_ASSIGNED_ORDERS_FAILURE:
      var result = Object.assign({}, state, {
        isLoading: false,
        currentPage: action.data.currentPage,
        pageSize: action.data.pageSize,
        totalPages: action.data.totalPages,
        data: action.data.data || initialState.data,
      });

      result &&
        result.data.map((data) => {
          return { statusName: renderDisc(data.status) };
        });
      return result;
  }
};

export default viewAssignedReducer;
